<template>
  <div style="position: relative" class="order-container">
    <div class="topBox header" style="height: 140px;">
      <div class="header-info-wrap flex-between-center">
        <div class="header-info">
          <div class="avatarBox">
            <img v-if="imgUrl" class="avatarImg" :src="imgUrl" />
            <img v-else class="avatarImg" src="../../assets/avatar.png" />
          </div>
          <div class="userInfBox">
            <div class="userName">{{ userInfo.realName }}</div>
            <div class="phone">{{ userInfo.phone }}</div>
          </div>
        </div>
        <div>
          <div class="loginOut" @click="myOut">登出</div>
          <div class="noticeCenter" @click="goNoticeCenter">通知中心</div>
        </div>
      </div>
      <div class="allOrder flex">
        <div class="flex1">
          <div class="order-amount">{{ orderCount.finishCount }}</div>
          <div class="order-status">已完成</div>
        </div>
        <div class="flex1 vux-1px-l">
          <div class="order-amount">{{ orderCount.unFinishCount }}</div>
          <div class="order-status">未完成</div>
        </div>
        <div class="flex1 vux-1px-l">
          <div class="order-amount">{{ orderCount.invalidCount }}</div>
          <div class="order-status">已失效</div>
        </div>
      </div>
    </div>
    <div class="searchBox" style="height: 50px;">
      <div class="selectBox vux-1px">
        <selector
          class="selector"
          v-model="search.status"
          @on-change="onSearch"
          :options="stateList"
        ></selector>
      </div>
      <div class="inputBox vux-1px">
        <x-input
          placeholder="客户/公司搜索"
          v-model="search.contactName"
          style="padding: 0 15px;"
          ref="input"
          :show-clear="false"
        >
          <x-icon
            slot="right"
            v-if="search.contactName.length > 0"
            type="clear"
            @touchstart.native="
              () => {
                $refs['input'].reset();
                $nextTick(() => onSearch());
              }
            "
          ></x-icon
        ></x-input>
      </div>
      <x-button class="searchButton" @click.native="onSearch">搜索</x-button>
    </div>
    <div
      class="scroller-container"
      style="position: absolute;top: 200px;bottom: 0;width: 100%;"
    >
      <Scroller ref="scroll" :loadData="loadData" rowKey="id" :gutter="10">
        <template v-slot="{ item, i }">
          <div
            v-if="item.kind == 1"
            class="order-item "
            @click="$router.push('/salesman/order/' + item.id)"
          >
            <div class="order-item-title vux-1px-b">
              <div>
                <div>订单时间：{{ item.createTime | date }}</div>
              </div>
              <div class="tag" v-if="item.type == 2">预售</div>
              <div
                class="order-item-status"
                :style="{ color: statusDetail[item.status].color }"
              >
                {{ statusDetail[item.status].label }}
              </div>
            </div>
            <div class="order-item-detail">
              <div class="itemImgBox">
                <img class="itemImg" :src="item.goodsDetails[0].image" />
              </div>
              <div class="order-item-detail-main">
                <div>
                  <div class="flex-between-center">
                    <div
                      class="order-item-detail-title"
                      v-html="
                        item.goodsDetails[0].name.replace(
                          /(\r\n|\n|\r)/,
                          '<br />'
                        )
                      "
                    ></div>
                    <div class="order-item-detail-price">
                      ￥{{ Number(item.goodsDetails[0].discountPrice) }}
                    </div>
                  </div>
                  <div class="flex-between-center">
                    <div class="order-item-detail-spec">
                      订购人: {{ item.contactName }}
                    </div>
                  </div>
                  <div class="flex-between-center">
                    <div class="order-item-detail-spec">
                      规格: {{ item.goodsDetails[0].volume }}
                    </div>
                    <div class="order-item-detail-quantity">
                      {{ item.goodsDetails[0].quantity }}
                    </div>
                  </div>
                </div>
                <div class="order-item-detail-total">
                  合计:
                  <span
                    >￥
                    {{ Number(item.goodsDetails[0].discountTotalPrice) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="order-item "
              @click="$router.push('/salesman/intOrder/' + item.id)"
            >
              <div class="order-item-title vux-1px-b">
                <div>
                  <div>订单时间：{{ item.createTime | date }}</div>
                </div>
<!--                <div class="tag" v-if="item.type == 2">预售</div>-->
                <div
                  class="order-item-status"
                  :style="{ color: statusDetail[item.status].color }"
                >
                  {{ statusDetail[item.status].label }}
                </div>
              </div>
              <div class="order-item-detail">
                <div class="order-item-detail-main">
                  <div>
                    <div class="flex-between-center">
                      <div class="order-item-detail-price">
                        Commodity：<span style="font-weight: normal">{{ item.intentionDetails.Commodity }}</span>
                      </div>
                    </div>
                    <div class="flex-between-center">
                      <div class="order-item-detail-price">
                        Quality：<span style="font-weight: normal">{{ item.intentionDetails.Quality }}</span>
                      </div>
                    </div>
                    <div class="flex-between-center">
                      <div class="order-item-detail-price">
                        Price：<span style="font-weight: normal">
                        <span v-if="item.goodsDetails">{{item.goodsDetails[0].price}}</span>
                        <span v-else>{{ item.intentionDetails ? item.intentionDetails.Price : '' }}</span>
                      </span>
                      </div>
                    </div>
                    <div class="flex-between-center">
                      <div class="order-item-detail-price">
                        Quantity：<span style="font-weight: normal">
                        <span v-if="item.goodsDetails">{{item.goodsDetails[0].quantity}}</span>
                        <span v-else>{{ item.intentionDetails ? item.intentionDetails.Quantity : '' }}</span>
                      </span>
                      </div>
                    </div>
                    <div class="flex-between-center">
                      <div class="order-item-detail-price">
                        订购人: <span style="font-weight: normal">{{ item.contactName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </Scroller>
    </div>

    <div class="footBox flex">
      <div class="flex2 genjin" @click="addNews">新增订单</div>
      <div class="flex2 genjin borderL" @click="addNewsI">新增国际贸易订单</div>
    </div>
  </div>
</template>

<script>
import { getAdminOrderList, getAdminOrderCount } from "@/api/order";
import Scroller from "@/components/Scroller";
import { statusDetail, statusEnumList } from "./enum";
import { mapActions, mapMutations } from "vuex";
import { Icon } from "vux";
export default {
  components: { Scroller, XIcon: Icon },
  name: "salesman",
  data() {
    return {
      orderCount: {},
      search: {
        status: "",
        contactName: ""
      },
      statusDetail,
      imgUrl: "",
      stateList: statusEnumList,
      query: {},
      loadData: params => {
        return getAdminOrderList({ ...params, ...this.search });
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.fetchCount();
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["CLEAR_ROLE"]),
    myOut() {
      let a = confirm("确定吗？");
      if (a) {
        this.handleLogout();
      } else {
        return false;
      }
    },
    handleLogout() {
      this.logout();
      this.CLEAR_ROLE();
      this.$navigation.cleanRoutes();
      this.$router.push({ name: "Login" });
    },
    goListDetail(id, state) {
      if (state == 0) {
        this.$router.push("/salesman/pending");
      } else if (state == 1) {
        this.$router.push("/salesman/follow");
      } else if (state == 2) {
        this.$router.push("/salesman/buyerConfirm");
      } else if (state == 3) {
        this.$router.push("/salesman/pay");
      } else {
        this.$router.push("/salesman/finsh");
      }
    },
    onSearch() {
      this.$refs["scroll"].refresh();
    },
    fetchCount() {
      getAdminOrderCount()
        .then(res => {
          this.orderCount = res;
        })
        .catch(e => this.$showError(e));
    },
    addNews() {
      // this.$router.push("/salesman/newOrder");
      this.$router.push("/salesman/orderList");
    },
    goNoticeCenter() {
      this.$router.push({ path: "/user/noticeCenter" });
    },
    addNewsI() {
      this.$router.push("/salesman/addNewI");
    }
  }
};
</script>

<style scoped lang="less">
.borderL {
  border-left: 1px solid #fff;
}
.tag {
  float: left;
  margin-left: 20px;
  margin-top: 18px;
  background: #039df8;
  color: #fff;
  padding: 5px 10px;
  border-radius: 80px;
  display: inline-block;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.footBox {
  position: fixed;
  width: 100%;
  height: 100px;
  line-height: 100px;
  bottom: 0;
  left: 0;
  z-index: 1;
  text-align: center;
  background: #fff;
}
.flex {
  display: flex;
}
.genjin {
  background: #039df8;
  color: #fff;
}
.flex2 {
  flex: 2;
}

.clear {
  clear: both;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.loginOut {
  width: 140px;
  height: 50px;
  background: rgba(13, 96, 182, 0.55);
  border-radius: 6px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 50px;
}
.noticeCenter {
  width: 140px;
  height: 50px;
  background: rgba(13, 96, 182, 0.55);
  border-radius: 6px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 50px;
  margin-top: 10px;
}
.topBox {
  width: 100%;
  background: url("~@/assets/traderbg.png");
  background-size: 100% 100%;
}

.avatarBox {
  width: 114px;
  height: 114px;
  border-radius: 50%;
  margin-right: 24px;
}

.avatarImg {
  width: 100%;
  height: 100%;
  border-radius: 60px;
  overflow: hidden;
}

.userInfBox {
  color: #fff;
}

.userName {
  font-size: 16px;
}

.phone {
  font-size: 12px;
}
.allOrder {
  color: #fff;
  font-size: 12px;
  margin-top: 40px;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}
.itemBox {
}

.textBox {
  position: relative;
  flex: 1;
  padding: 10px 0;
  margin-left: 10px;
}
.itemTitle {
  height: 60px;
  line-height: 60px;
  font-size: 15px;
  color: #000;
}
.name {
  position: absolute;
  bottom: 54px;
  left: 0;
  font-size: 14px;
  color: #5b575a;
}
.price {
  position: absolute;
  bottom: 10px;
  left: 0;
  font-size: 15px;
  color: #5b575a;
}
.state {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 1;
  color: red;
  font-size: 14px;
}
.selectBox {
  font-size: 12px;
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  width: 200px;
  margin-left: 30px;
}
.selector {
  height: 60px;
  line-height: 60px;
}
.inputBox {
  font-size: 12px;
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  width: 300px;
  margin-left: 30px;
  > input {
    height: 100%;
    width: 100%;
  }
}
.xInput {
  padding: 0 20px;
  height: 80px;
  line-height: 80px;
}
.searchButton {
  font-size: 12px;
  float: right;
  width: 140px;
  margin: 10px 20px;
  height: 60px;
  line-height: 60px;
  color: #fff;
  background: #039df8;
  text-align: center;
  border-radius: 10px;
}
.searchBox {
  padding-top: 20px;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
}
.header {
  &-info {
    display: flex;
    align-items: flex-end;
    &-wrap {
      padding: 24px 36px 0;
    }
  }
  .order-amount {
  }
  .order-status {
    color: #b3daff;
  }
  .vux-1px-r::before {
    border-color: rgba(0, 0, 0, 0.3);
  }
}
.order {
  &-container {
    height: 100%;
    & /deep/ .scroll-wrapper {
      position: relative;
    }
    & /deep/ .list-content {
      padding-top: 20px;
    }
  }
  &-amount {
    font-size: 20px;
    line-height: 1.2em;
  }
  &-status {
    font-size: 12px;
    line-height: 1em;
  }
  &-item {
    padding: 0 30px 0;
    background: #fff;
    &-title {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(71, 71, 71, 1);
      line-height: 80px;
    }
    &-status {
      font-size: 12px;
    }
    &-detail {
      display: flex;
      padding: 24px 0;
      .itemImgBox {
        width: 140px;
        height: 140px;
        margin-right: 32px;
        flex: none;
      }
      .itemImg {
        width: 100%;
        height: 100%;
      }
      &-main {
        display: flex;
        flex: 1;
        flex-flow: column;
        justify-content: space-between;
      }
      &-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(17, 17, 17, 1);
      }
      &-price {
        font-size: 11px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(82, 82, 82, 1);
      }
      &-spec,
      &-quantity {
        font-size: 12px;
        line-height: 1.5em;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(145, 145, 145, 1);
      }
      &-total {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(83, 83, 83, 1);
        & > span {
          color: #ff3600;
          font-size: 15px;
        }
      }
    }
  }
}
</style>
